import type { ReactElement } from 'react';
import type { RfqStatusFilter, RfqTileCounts, UserRole } from '../../domain/types';

interface RfqTilesProps {
  role: UserRole;
  counts: RfqTileCounts;
  statusFilter: RfqStatusFilter;
  onStatusFilter: (filter: RfqStatusFilter) => void;
}

function tileClass(active: boolean): string {
  return `tile ${active ? 'tile-active' : ''}`;
}

/** Operations managers only work the approval queue (same filters as /api/operations/rfq). */
export function RfqTiles({ role, counts, statusFilter, onStatusFilter }: RfqTilesProps): ReactElement {
  if (role === 'OperationsManager') {
    return (
      <section className="tiles-grid">
        <article className={tileClass(statusFilter === 'all')} onClick={() => onStatusFilter('all')}>
          <h3>All</h3>
          <p>{counts.all}</p>
        </article>
        <article
          className={tileClass(statusFilter === 'pendingApproval')}
          onClick={() => onStatusFilter('pendingApproval')}
        >
          <h3>Pending approval</h3>
          <p>{counts.pendingApproval}</p>
        </article>
        <article className={tileClass(statusFilter === 'approved')} onClick={() => onStatusFilter('approved')}>
          <h3>Approved</h3>
          <p>{counts.approved}</p>
        </article>
        <article className={tileClass(statusFilter === 'rejected')} onClick={() => onStatusFilter('rejected')}>
          <h3>Rejected</h3>
          <p>{counts.rejected}</p>
        </article>
      </section>
    );
  }

  return (
    <section className="tiles-grid tiles-grid--rfq">
      <article className={tileClass(statusFilter === 'all')} onClick={() => onStatusFilter('all')}>
        <h3>All</h3>
        <p>{counts.all}</p>
      </article>
      <article className={tileClass(statusFilter === 'draft')} onClick={() => onStatusFilter('draft')}>
        <h3>Draft</h3>
        <p>{counts.draft}</p>
      </article>
      <article className={tileClass(statusFilter === 'requestSent')} onClick={() => onStatusFilter('requestSent')}>
        <h3>Request sent</h3>
        <p>{counts.requestSent}</p>
      </article>
      <article
        className={tileClass(statusFilter === 'partialReceived')}
        onClick={() => onStatusFilter('partialReceived')}
      >
        <h3>Partial quotes</h3>
        <p>{counts.partialReceived}</p>
      </article>
      <article className={tileClass(statusFilter === 'received')} onClick={() => onStatusFilter('received')}>
        <h3>All quotes in</h3>
        <p>{counts.received}</p>
      </article>
      <article
        className={tileClass(statusFilter === 'pendingApproval')}
        onClick={() => onStatusFilter('pendingApproval')}
      >
        <h3>Pending approval</h3>
        <p>{counts.pendingApproval}</p>
      </article>
      <article className={tileClass(statusFilter === 'approved')} onClick={() => onStatusFilter('approved')}>
        <h3>Approved</h3>
        <p>{counts.approved}</p>
      </article>
      <article className={tileClass(statusFilter === 'rejected')} onClick={() => onStatusFilter('rejected')}>
        <h3>Rejected</h3>
        <p>{counts.rejected}</p>
      </article>
      <article className={tileClass(statusFilter === 'cancelled')} onClick={() => onStatusFilter('cancelled')}>
        <h3>Cancelled</h3>
        <p>{counts.cancelled}</p>
      </article>
      <article className={tileClass(statusFilter === 'complete')} onClick={() => onStatusFilter('complete')}>
        <h3>Complete</h3>
        <p>{counts.complete}</p>
      </article>
    </section>
  );
}
